import React from 'react';
import { useState} from 'react';
import { Alert } from 'react-bootstrap';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Form } from 'react-bootstrap';
 


function AgendaAjout(props) {

  const [isLoading, setIsLoading] = useState(false);
  const [error,setError] = useState(false);
  const [sucess, setSucess] = useState(false);
  const [ajouter,setAjouter] = useState(false);
  const [date_debut,setDate_debut] = useState("");
  const [date_fin,setDate_fin] = useState("");
  const [heure_debut,setHeure_debut] = useState("");
  const [heure_fin,setHeure_fin] = useState("");
  const [localisation,setLocalisation] = useState("");
  const [couleur,setCouleur] = useState("");
  const [sujet,setSujet] = useState("");
  const apiUrl = process.env.REACT_APP_API_URL;



  const handleSubmit = async (e) => {
    setIsLoading(true);
    const fetchData = async () => {
      try {

       if (!date_debut || !date_fin || !heure_debut || !heure_fin || !localisation || !couleur || !sujet) {
          setError("Veuillez remplir tous les champs du formulaire.");
          setIsLoading(false);
          return;
        }
        await axios.post(
          `${apiUrl}/agenda/ajout`,
          {
            idEquipe : props.userData.user.donnée.results[0].id_equipe,
            date_debut:date_debut,
            date_fin:date_fin,
            heure_debut:heure_debut,
            heure_fin:heure_fin,
            localisation:localisation,
            couleur:couleur,
            sujet:sujet
          },
          {
            withCredentials: true // Permet de transmettre les cookies avec la requête
          }
        );
        setError(null);
        setIsLoading(false);
        setDate_debut("");
        setDate_fin("");
        setHeure_debut("");
        setHeure_fin("");
        setLocalisation("");
        setSujet("");
        setCouleur("");
        setSucess(true);
        window.location.reload();



      } catch (error) {
        if (error.response) {
            
          setError(error.response.data.message);
        } else {
       
          setError(true)
        }
        setIsLoading(false);

      }
    };

    fetchData(); 
  };

        if (isLoading) {
          return (
          <div className="centered-content">
            <img src="/img/logo.png" alt="Logo" className="centered-logo" />
            <br/>
            <span className="loader"></span>
          </div>
          
          );  
        }


  return (
  <>
        {ajouter && (
        <Modal show={ajouter} onHide={() => setAjouter(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Ajouter un événement</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <>Êtes-vous sûr d'ajouter cette événement  ?</>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setAjouter(false)}>
              Annuler
            </Button>
            <Button variant="primary"  onClick={(e) => {handleSubmit(e);setAjouter(false)}} style={{ backgroundColor: "#00E676", borderColor: '#00E676' }}>
              Ajouter
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <h2>Ajouter un événement dans l'agenda de l'équipe</h2>
      <hr/>
      {error && (
          <Alert key="danger" variant="danger"  style={{fontSize:"15px", margin:"auto", width : "90%"}}>
            Erreur ! {error}
          </Alert>
        ) }
        {sucess &&(
          <Alert key="success" variant="success" style={{ fontSize: "15px", margin: "auto", width: "80%" }}>
              Félicitations ! L'événement a été ajouté avec succès.
           </Alert>
        )}
      <Form >
            <Form.Label style={{fontSize:'15px'}}>Date de début</Form.Label>
            <br/>
            <input
                name="date_debut"
                type="date"
                id="date_debut"
                required
                value={date_debut} onChange={(e) => {setDate_debut(e.target.value)}}
                style={{width: '100%', borderRadius : '5px', padding:'.375rem .75rem'}}
              />           
            <br/>
            <Form.Label style={{fontSize:'15px'}}>Date de fin</Form.Label>
            <br/>
            <input
              name="date_fin"
              type="date"
              id="date_fin"
              required
              value={date_fin} onChange={(e) => {setDate_fin(e.target.value)}}
              style={{width: '100%', borderRadius : '5px', padding:'.375rem .75rem'}}
            />
            <br/>
            <Form.Label style={{fontSize:'15px'}}>Heure de début</Form.Label>
            <br/>
            <input
                type="time"
                id="heure_debut"
                name="heure_debut"
                required
                value={heure_debut} onChange={(e) => {setHeure_debut(e.target.value)}}
                style={{width: '100%', borderRadius : '5px', padding:'.375rem .75rem'}}
              />
            <br/>
            <Form.Label style={{fontSize:'15px'}}>Heure de fin</Form.Label>
            <br/>
            <input
                type="time"
                id="heure_fin"
                name="heure_fin"
                required
                value={heure_fin} onChange={(e) => {setHeure_fin(e.target.value)}}
                style={{width: '100%', borderRadius : '5px', padding:'.375rem .75rem'}}
              />
            <br/>
            <Form.Label style={{fontSize:'15px'}}>Lieu de l'événement</Form.Label>
            <Form.Control type="text" placeholder="Entrez le lieu de l'événement"value={localisation} onChange={(e) => {setLocalisation(e.target.value)}} required />
            <Form.Label style={{fontSize:'15px'}}>Couleur</Form.Label>
            <br/>
            <label className={`color-option vert ${couleur === 'color-1' ? 'selected' : ''}`}  onClick={() => setCouleur("color-1")}>
                <input type="radio" name="couleur" value="vert" style={{display:"none"}}  />
            </label>
            &nbsp;
            <label className={`color-option jaune ${couleur === 'color-2' ? 'selected' : ''}`}  onClick={() => setCouleur("color-2")}>
              <input type="radio" name="couleur" value="jaune" style={{display:"none"}} />
            </label>
            &nbsp;
            <label className={`color-option rouge ${couleur === 'color-3' ? 'selected' : ''}`}  onClick={() => setCouleur("color-3")}>
               <input type="radio" name="couleur" value="rouge" style={{display:"none"}} />
            </label>
            &nbsp;
            <label className={`color-option bleu ${couleur === 'color-4' ? 'selected' : ''}`}  onClick={() => setCouleur("color-4")}>
               <input type="radio" name="couleur" value="bleu" style={{display:"none"}} />
            </label>
            <br/>
            <Form.Label style={{fontSize:'15px'}}>Sujet de l'événement</Form.Label>
            <Form.Control as="textarea" placeholder="Ajoutez un commentaire"  rows={3} value={sujet} onChange={(e) => {setSujet(e.target.value)}} />
            <div style={{textAlign:"right"}}>
              <Button variant="primary" onClick={(e) => { e.preventDefault(); setAjouter(true); }}style={{ marginTop: '1rem',backgroundColor:"#00E676", borderColor:'#00E676' }}>
                Organiser l'événement
              </Button>
            </div>
        </Form>
        <br/>
      
      </>
  );
}

export default AgendaAjout;
